import(/* webpackMode: "eager" */ "/home/runner/work/dex-frontend/dex-frontend/apps/web/src/app/(networks)/(evm)/pool/incentivize/page.tsx");
